import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Input } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { password as change } from "../../api/Profile"

/* Swal */
import Swal from "sweetalert2"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"



/* Page Password */
class Password extends Component {

    constructor() {
        super()

        this.state = {
            password: "",
            newPassword: "",
            repeatPassword: "",
            waiting: false,
        }
    }

    /* Save action */
    save = () => {

        const { password, newPassword, repeatPassword } = this.state

        if (password === "") {
            this._password.error(t("profile.error.emptyCurrentPwd"))
            return
        }

        if (password.length < 8) {
            this._password.error(t("profile.error.shortCurrentPwd"))
            return
        }

        if (newPassword === "") {
            this._newPassword.error(t("profile.error.emptyNewPwd"))
            return
        }

        if (newPassword.length < 8) {
            this._newPassword.error(t("profile.error.shortNewPwd"))
            return
        }

        if (newPassword !== repeatPassword) {
            this._repeatPassword.error(t("profile.error.mismatch"))
            return
        }

        this._password.error("")
        this._newPassword.error("")
        this._repeatPassword.error("")

        this.setState({ waiting: true })

        change({ password, newPassword }).then((response) => {
            if (response.status === 200) {
                this.setState({ waiting: false, password: "", newPassword: "", repeatPassword: "" })
                Swal.fire(utils.notification(t("profile.passwordChanged"), "success"))
            }
            else if (response.status === 401) {
                this.setState({ waiting: false })
                this._password.error(t("profile.error.wrongPassword"))
            }
            else if (response.status === 498) {
                this.setState({ waiting: false })
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                this.setState({ waiting: false })
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            this.setState({ waiting: false })
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        })
    }

    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        const { password, newPassword, repeatPassword } = this.state

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("profile.changePassword")}</h1>
                </div>

                <div className="page-form">

                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._password = ref} label={t("profile.currentPassword")} value={password} onChange={(event) => this.setState({ password: event.target.value })} secure />
                            <div className="form-space" />
                            <Input ref={(ref) => this._newPassword = ref} label={t("profile.newPassword")} value={newPassword} onChange={(event) => this.setState({ newPassword: event.target.value })} secure />
                            <Input ref={(ref) => this._repeatPassword = ref} label={t("profile.repeatPassword")} value={repeatPassword} onChange={(event) => this.setState({ repeatPassword: event.target.value })} secure />
                        </div>
                    </div>

                    <div className="form-bottom">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Password)